<template>
	<RightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<ModalVScrollable class="member-info"
			title="メンバー情報"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header v-if="isEditable">
				<div class="modal-header-member-info">
					<v-btn flat blue large color="white" v-on:click="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="deleteMe">削除</v-btn>
				</div>
			</template>
			<template v-if="value">
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 v-bind:class="classNameLabel" v-bind:style="styleTextfieldLabel">
						名前
					</v-flex>
					<v-flex xs10 class="content-name">
						<template v-if="isEditable">
							<v-text-field
								v-model=value.member.name
								maxlength="40"
								:rules="[rules.required, rules.name_length]"
								counter
							></v-text-field>
						</template>
						<template v-else>
							{{ value.member.name }}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 class="small-label" v-bind:style="styleTextfieldLabel">
						連絡先
					</v-flex>
					<v-flex xs10 class="content">
						<template v-if="isEditable">
							<v-text-field
								v-model=value.member.tel
								maxlength="20"
								:rules="[rules.validate, rules.tel_length]"
								counter
							></v-text-field>
						</template>
						<template v-else>
							{{ value.member.tel }}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 class="multi-line-label">
						一言
					</v-flex>
					<v-flex xs10 class="content row-group-multi-line">
						<template v-if="isEditable">
							<v-textarea
								v-model=value.member.comment
								outline
								maxlength="50"
								:rules="[rules.comment_length]"
								counter
							></v-textarea>
						</template>
						<template v-else>
							{{ value.member.comment }}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mx-2 mb-2 mt-3 pr-2>
					<v-flex xs2 d-flex align-start class="multi-line-label">
						分類
					</v-flex>
					<v-flex xs10 class="content">
						<Classes
							:items="value.member.classes"
							:max_width="isEditable ? 224: 264"
							:all_show=true
						/>
						<v-btn flat fab class="btn-add-class" v-if="isEditable">
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-layout wrap mx-2 pt-3 pr-2>
					<v-flex xs2 d-flex align-start class="multi-line-label">
						備考
					</v-flex>
					<v-flex xs10 class="content row-group-multi-line">
						<template v-if="isEditable">
							<v-textarea
								v-model=value.member.remarks
								outline
								maxlength="100"
								:rules="[rules.remarks_length]"
								counter
							></v-textarea>
						</template>
						<template v-else>
							{{ value.member.remarks }}
						</template>
					</v-flex>
				</v-layout>

				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 class="label">
						ID
					</v-flex>
					<v-flex xs10 class="content">
						<template v-if="isEntry">
							<v-text-field
								v-model=value.member.login_id
								maxlength="20"
								:rules="[rules.required, rules.validate, rules.length]"
								counter
							></v-text-field>
						</template>
						<template v-else>
							{{ value.member.login_id }}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 class="label" v-bind:style="styleTextfieldLabel">
						PASS
					</v-flex>
					<v-flex xs10 class="content">
						<template v-if="isEditable">
							<template v-if="isEntry || isMyself">
								<v-text-field
									v-model=value.member.login_passwd
									:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
									:type="show_passwd ? 'text' : 'password'"
									@click:append="show_passwd = !show_passwd"
									maxlength="20"
									:rules="[rules.required, rules.validate, rules.length]"
									counter
								></v-text-field>
							</template>
							<template v-else>
								<v-text-field
									v-model=value.member.login_passwd
									:append-icon="isInvalid ? 'block' : 'check_circle_outline'"
									:type="'password'"
									@click:append="onClickInvalid"
									readonly
								></v-text-field>
							</template>
						</template>
						<template v-else>
							{{ maskPassword }}
						</template>
					</v-flex>
				</v-layout>
				<v-layout wrap mt-3 mb-3 mx-2 pr-2>
					<v-flex xs2 class="label" v-bind:style="styleTextfieldLabel">
						権限
					</v-flex>
					<v-flex xs10 class="content">
						<template v-if="isEditable">
							<v-select
								:value="memberPermissionRole"
								:items="permission_roles"
								@input="onSelectePermission"
								item-text="text"
								item-value="id"
								label="Select"
								return-object
								single-line
							></v-select>
						</template>
						<template v-else>
							{{ memberPermissionName }}
						</template>
					</v-flex>
				</v-layout>
			</template>
		</ModalVScrollable>
	</RightPane>
</template>
<script>


import RightPane from './RightPane';
import ModalVScrollable from './ModalVScrollable';
import Classes from './Classes';
import Util from '../classes/Util';
import { INVALID_FLAG, PERMISSION, FORM_MODE} from '../classes/Const';

const MASK_WORD = "･";

const validateLengthName = function(value) {
	if(value.length <= 40)
		return true;
	return false;
};

const validateLengthTel = function(value) {
	if(value.length <= 20)
		return true;
	return false;
};

const validateLengthComment = function(value) {
	if(value.length <= 50)
		return true;
	return false;
};

const validateLength = function(value) {
	if(value.length >= 6 && 20 >= value.length)
		return true;
	return false;
};

const validateLengthRemarks = function(value) {
	if(value.length <= 100)
		return true;
	return false;
};
export default {
	name: 'RightPaneMemberInfo',
	props: [
		'value',
	],
	components: {
		RightPane,
		ModalVScrollable,
		Classes,
	},
	data: function() {
		return {
			rules: {
				required: v => !!v || '入力してください',
				validate: v => (!v) ? true : Util.isValidCharPassword(v) || '無効な文字が含まれています',
				name_length: v => validateLengthName(v) || '40文字以内で入力してください',
				tel_length: v => validateLengthTel(v) || '20文字以内で入力してください',
				comment_length: v => validateLengthComment(v) || '50文字以内で入力してください',
				length: v => validateLength(v) || '6文字以上20文字以下で入力してください',
				remarks_length: v => validateLengthRemarks(v) || '100文字以内で入力してください',
			},
			show_passwd: false,
			permission_roles: [
				{ id: PERMISSION.ROLE.SYSTEM_ADMIN, text: 'システム管理者'},
				{ id: PERMISSION.ROLE.ADMIN, text: '管理者'},
				{ id: PERMISSION.ROLE.MEMBER, text: '一般メンバー'},
				{ id: PERMISSION.ROLE.SUB_MEMBER, text: 'サブメンバー'},
				{ id: PERMISSION.ROLE.GUEST, text: 'ゲスト'},
			],
		}
	},
	methods: {
		onClose: function() {
			this.$emit('close');
		},
		onClickDone: function(){
		},
		deleteMe: function(){
		},
		onClickInvalid: function() {
			this.value.member.invalid = this.isInvalid ? INVALID_FLAG.VALID : INVALID_FLAG.INVALID;
		},
		onSelectePermission: function(value) {
			this.value.member.permission = value.id;
		},
	},
	computed: {
		display: function() {
			return this.value!== undefined && this.value !== null;
		},
		isEditable: function() {
			return (this.display && this.value.mode !== FORM_MODE.REFERENCE);
		},
		classNameLabel: function() {
			if(this.isEditable)
				return ['label'];
			else
				return ['multi-line-label'];
		},
		isEntry: function() {
			return false;
		},
		isMyself: function() {
			return this.value.member.code === this.$store.getters.loginUser.code;
		},
		isInvalid: function() {
			return this.value.member.invalid === INVALID_FLAG.INVALID;
		},
		maskPassword: function() {
			let mask_password = "";
			let strLen = this.value.member.login_passwd.length;
			for (let i = 0; i < strLen; i++) {
				mask_password += MASK_WORD;
			}
			return mask_password;
		},
		memberPermissionRole: function() {
			let p = this.permission_roles.filter(p =>{ return p.id === this.value.member.permission })[0];
			if (!p)
				return null;
			return p;
		},
		memberPermissionName: function() {
			let p = this.memberPermissionRole;
			if (!p) 
				return "";
			return p.text;
		},
		styleTextfieldLabel: function(){
			if(this.isEditable)
				return {"margin-top" : -4 + "px"};
			else
				return "";
		},
	},
	watch: {
	},
}
</script>
<style>
	.modal-window.member-info .row-group {
		height: 60px;
	}
	.modal-window.member-info .row-group-multi-line {
		min-height: 150px;
	}
	.modal-window.member-info .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.member-info .small-label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
	}
	.modal-window.member-info .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.member-info .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.member-info .content-name {
		word-wrap: break-word;
		font-size: 16px;
	}
	.modal-window.member-info .modal-header-member-info {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.member-info .btn-add-class {
		height: 24px;
		width: 24px;
		margin: 0px;
	}
</style>
